import apiService from '../../services/api';

// Init state
const state = {
    items: []
};

// Actions
const actions = {
    getList: (context, params) => {
        return apiService.get('report.index', params);
    },
    create: (context, params) => {
        return apiService.post('report.index', params);
    },
    update: (context, params) => {
        return apiService.put('report.detail', params);
    },
    delete: (context, params) => {
        return apiService.delete('report.detail', params);
    }
};

// Mutation
const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations
};
